const mapStateToProps = state => ({});
export default mapStateToProps;
